export function buildImageUrl(path?: string): string {
  if (!path) return "/img/logo/LogoLinkServs.png";

  const clean = path.trim();

  try {
    const url = new URL(clean);
    return url.toString(); // ya es absoluta
  } catch {}

  return `${import.meta.env.VITE_ASSETS_URL}/${clean.replace(/^\/+/, "")}`;
}

export function buildDocumentUrl(path?: string): string {
  if (!path) return "";

  if (path.startsWith("http")) return path;

  return `${import.meta.env.VITE_ASSETS_URL}/${path.replace(/^\/+/, "")}`;
}

